import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Button } from './ui/button';
import { Mail, Loader2 } from 'lucide-react';
import { api } from '../lib/api';
import { toast } from 'sonner';

/** Generic dialog to send a doc (preventivo/fattura/reminder) via email. */
export const SendEmailDialog = ({ open, onOpenChange, endpoint, defaultEmail = '', docLabel = 'documento', onSent }) => {
    const [email, setEmail] = useState(defaultEmail);
    const [loading, setLoading] = useState(false);

    const send = async () => {
        if (!email || !email.includes('@')) {
            toast.error('Inserisci un indirizzo email valido');
            return;
        }
        setLoading(true);
        try {
            await api.post(endpoint, { to_email: email });
            toast.success(`Email inviata a ${email}`);
            onOpenChange(false);
            onSent?.();
        } catch (e) {
            toast.error(e.response?.data?.detail || 'Errore invio email');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md">
                <DialogHeader><DialogTitle className="font-display text-2xl flex items-center gap-2"><Mail className="w-5 h-5 text-[hsl(var(--accent))]" /> INVIA {docLabel.toUpperCase()}</DialogTitle></DialogHeader>
                <div className="space-y-3 mt-2">
                    <div>
                        <Label>Email destinatario</Label>
                        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="cliente@email.it" className="mt-1" data-testid="send-email-input" autoFocus />
                    </div>
                    <p className="text-xs text-[hsl(var(--muted-foreground))]">
                        L'email sarà inviata da <strong>noreply@cantiereai.com</strong> con il {docLabel} in allegato (se applicabile).
                    </p>
                    <div className="flex gap-2">
                        <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1">Annulla</Button>
                        <Button onClick={send} disabled={loading} className="flex-1 bg-[hsl(var(--accent))] hover:bg-[hsl(45_100%_48%)] text-[hsl(220_13%_10%)] font-bold" data-testid="send-email-submit">
                            {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Invio…</> : <><Mail className="w-4 h-4 mr-2" /> Invia</>}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
